import ReturnPolicyPage from './ReturnPolicyPage';

export default ReturnPolicyPage;
